export default "__VITE_ASSET__BxLcSasC__"